module.exports = __WEBPACK_EXTERNAL_MODULE_129__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 129
// module chunks = 0